const post = async (path, body) => {
  const response = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok) {
    const error = new Error(data?.error || "Chess request failed");
    error.payload = data;
    error.status = response.status;
    throw error;
  }
  return data;
};

export const chessPresence = (userId, displayName, mode) =>
  post("/api/chess/presence", { userId, displayName, mode });

export const chessSelect = (userId, displayName, opponentId, mode) =>
  post("/api/chess/select", { userId, displayName, opponentId, mode });

export const chessMove = (userId, gameId, move) =>
  post("/api/chess/move", {
    userId,
    gameId,
    from: move.from,
    to: move.to,
    promotion: move.promotion,
  });

export const chessLeave = (userId) => {
  if (!userId) return Promise.resolve();
  return post("/api/chess/leave", { userId }).catch(() => {});
};
